// IE 2026 09 24 / ODOO-… (заказ Игоря: объяснение элементов по Alt): ЯДРО «ОБЪЯСНЕНИЙ ПО ALT» — общий механизм для всех элементов платформы.
// Заказ (24.09, дословно): «Когда я навожу на иконку со звёздочкой и нажимаю и держу Alt, то я хочу видеть Tooltip для этой звёздочки, который бы
// говорил не только что это избранное, но и … какую функциональность несёт включение-выключение этой галочки. Проанализируй все визуальные элементы
// на всех [наших пейджах]: [с] зажатым Alt я хочу видеть объяснение — что это, зачем это, как это влияет на другие…».
//
// Как устроено:
// - реестр (utils/uiHelp/index.js) сливает карты областей: ключ '<область>.<элемент>' → функция (vars, ctx) → запись { title, what, why, click, now,
//   affects, stored, setting, hotkey, states: { <состояние>: текст } }; строки в записи — английские литералы в t() (словари uk / ru), {name} подставляется
//   из vars ПОСЛЕ перевода (uiHelp_entry); пустые поля не выводятся; now — явное поле, иначе states[состояние];
// - директива v-uiHelp (регистрация в main.js): значение 'ключ' либо { key, state: () => 'on' | 'off' | …, vars: () => ({ … }) } (state / vars —
//   функции, считаются В МОМЕНТ ПОКАЗА, поэтому «Now» всегда свежий). Ставит data-help="<ключ>" (пробы, отладка) и регистрирует элемент тем же
//   механизмом, что стандартная «ленивая» подсказка платформы (altTooltip._bindFn = v-wjTooltipFn: показ при зажатом Alt / в режиме Show tooltips,
//   дожитие после Alt, возврат после чужого hide/dispose wijmo — всё как у прочих подсказок) и в той же разметке (store.tooltip_html: строки
//   <b class='tooltip-header'>Ключ:</b> <b class='tooltip-text'> значение</b>); шапка — title жирным (<b class='ui-help-title' data-help-key=…>);
// - вложенность: элемент с объяснением внутри строки со своей подсказкой (звезда в пункте панели) — при Alt ближайший источник вверх по DOM (altTooltip._find),
//   то есть объяснение звезды; ушёл со звезды на строку — снова подсказка строки; Alt, нажатый над звездой, — объяснение звезды. В режиме Show tooltips
//   wijmo не показывает подсказку вложенного элемента, пока видна подсказка внешнего (курсор «внутри владельца»), поэтому директива сама показывает
//   своё объяснение по mouseenter (uiHelp._onEnter), а по mouseleave wijmo прячет его, и внешняя строка показывает свою;
// - IE 2026 09 25 / ODOO-… (правило Игоря: подсказки только по Alt или опции): короткое имя по обычному наведению — только при fe.ux.hoverTooltips=true (прежнее поведение); по умолчанию без Alt
//   и без Show tooltips не показывается ничего (затвор ядра altTooltip.hoverTipsOn); строка ниже описывает прежний режим:
// - ОБЫЧНОЕ наведение (без Alt и без Show tooltips) подсказку не теряет (поправка координатора 24.09): где раньше был нативный title или always-on
//   v-wjTooltip, по-прежнему показывается КОРОТКОЕ имя — тем же элементом подсказки платформы (wijmo), а не нативным окном, после паузы
//   fe.ux.tooltipShowDelayMs (400 мс); источник короткого имени: binding.short → перенесённый нативный title → статичная v-wjTooltip элемента;
//   полное объяснение — только по Alt / Show tooltips (звезда без Alt — «Обране», с Alt — полное объяснение);
// - нативный title у элемента с объяснением переносится в aria-label (два окна не накладываются); выключено — title возвращается;
// - элементы, у которых УЖЕ есть своя подсказка v-wjTooltipFn (пункты панелей с кнопками tipActions, плитки и группы рейла, строки столов), директивой
//   не перекрываются: объяснение дописывается строками в их подсказку (uiHelp_rows / uiHelp_rowsHtml), кнопки действий сохраняются;
// - выключатель: настройка базы fe.ux.uiHelp (по умолчанию вкл.; false — как было: объяснений нет, нативный title на месте):
//   window.feSettings.set('fe.ux.uiHelp', false) / .unset(…); счётчики и консоль — window._uiHelp (stats.shows по ключам, keys(), html(key, opts)).
// Компоновка с чужими подсказками: uiHelp_rows(ключ, { vars, state }) → { «Подпись»: текст } — добавить строки объяснения к своей подсказке
// (так пункты панелей-меню получают строки Click / Now / Formatting рядом с прежними Menu item / Group / Command / ID).
// Точка расширения — объяснения ЗАПИСЕЙ (следующая волна: пункты, ячейки-ссылки, рейл, сайдбар): поставщик (id, segment, ctx) → поля объяснения | null
// (null — не загружено / нечего сказать); регистрация uiHelp_addRecordProvider(fn, имя), строки — uiHelp_recordRows / uiHelp_recordRowsHtml (подсказка
// собирает их в момент показа), пришли асинхронные данные — uiHelp_recordReady(id, segment): видимая подсказка перерисовывается штатным повторным
// показом (uiHelp_reshow) + событие window 'ui-help:record' {id, segment} для владельцев с собственным показом (ячейки грида).
// IE 2026 09 24 / ODOO-… (заказ Игоря: объяснение элементов по Alt) · U1 (проверка и доводка ядра): поле how («How to use» — контракт record_help: what / why /
// how / source / title), uiHelp_recordEntry (запись поставщика целиком: title / source — для шапки и отладки), готовый поставщик «пачкой» uiHelp_recordBatchProvider
// (кэш, одна пачка на паузу, смена языка, повтор после ошибки, ОДИН повторный показ на пачку); повторный показ умеет и ячейку грида (подсказка ячейки считается
// AttrGrid.cellTooltip по ячейке, а не функцией элемента) — владельцам со своим показом слушать 'ui-help:record' больше не обязательно.
// Юнит рендера — handoff-files/ui-help-2026-09-24/uiHelp.test.mjs; проба — tools/probes/uihelp_check.mjs; API — handoff-files/ui-help-2026-09-24/README.md.
import { Tooltip, Control } from '@mescius/wijmo'
import { t, getLanguage } from '@/i18n'
import altTooltip from './altTooltip'
import { UI_HELP, uiHelp_register, uiHelp_keys } from './uiHelp/index.js'

export { uiHelp_register, uiHelp_keys }

// поля записи в порядке вывода; подписи — t() литералами (правило i18n)
// IE 2026 09 24 / ODOO-… (заказ Игоря: объяснение элементов по Alt) · U1: how — «как использовать» (объяснения записей, контракт record_help)
export const UI_HELP_ROWS = ['what', 'why', 'how', 'click', 'now', 'affects', 'stored', 'setting', 'hotkey']
export function uiHelp_label(field) {
    switch (field) {
        case 'what': return t('What it is')
        case 'why': return t('Why')
        case 'how': return t('How to use')   // IE 2026 09 24 / ODOO-… (заказ Игоря: объяснение элементов по Alt) · U1
        case 'click': return t('Click')
        case 'now': return t('Now')
        case 'affects': return t('Affects')
        case 'stored': return t('Stored')
        case 'setting': return t('Setting')
        case 'hotkey': return t('HotKey')
        case 'format': return t('Formatting')
        default: return String(field || '')
    }
}

export const escHtml = (s) => String(s ?? '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#39;')
// {name} → vars.name (после перевода); неизвестное имя остаётся как есть — видно в пробе
export const uiHelp_subst = (s, vars) => String(s).replace(/\{(\w+)\}/g, (m, k) => (vars && vars[k] !== undefined && vars[k] !== null) ? String(vars[k]) : m)

const TTIP = (Control && Control._TTIP_KEY) || '$WJ-TTIP'
const MUTE = '__uiHelpMuted'

const stats = { binds: 0, renders: 0, total: 0, shows: {}, enters: 0, shorts: 0, errors: 0, refreshes: 0, titles: 0, recordAsks: 0, recordHits: 0, recordReady: 0, reshows: 0 }

let _store = null
export function uiHelp_setStore(store) { _store = store }
const storeOf = () => _store || altTooltip.store || null

// выключатель fe.ux.uiHelp (настройка базы / override браузера); до установки стора — включено
export function uiHelp_enabled() {
    try { const s = storeOf(); return !(s && typeof s.setting === 'function' && s.setting('fe.ux.uiHelp', true) === false) } catch (e) { return true }
}
export function uiHelp_has(key) { return typeof UI_HELP[key] === 'function' }

// запись по ключу: строки переведены, {name} подставлены; null — ключа нет / запись пуста / ошибка
export function uiHelp_entry(key, opts = {}) {
    const fn = UI_HELP[key]
    if (typeof fn !== 'function') return null
    const vars = (opts && opts.vars) || {}
    const state = (opts && opts.state !== undefined) ? opts.state : null
    let e
    try { e = fn(vars, { state, key }) } catch (err) { stats.errors++; try { console.warn('uiHelp: entry failed', key, err) } catch (x) { /* без консоли */ } return null }
    if (!e || typeof e !== 'object') return null
    const out = {}
    for (const f of ['title', ...UI_HELP_ROWS]) {
        let v = e[f]
        if (f === 'now' && (v === undefined || v === null || v === '') && e.states && state !== null && state !== undefined) v = e.states[state]
        if (v === undefined || v === null || v === '') continue
        const s = uiHelp_subst(v, vars).trim()
        if (s) out[f] = s
    }
    return Object.keys(out).length ? out : null
}

// подсказка-объяснение: шапка (title жирным, data-help-key) + строки «Подпись: текст» в разметке store.tooltip_html; '' — объяснения нет
export function uiHelp_html(key, opts = {}) {
    const e = uiHelp_entry(key, opts)
    if (!e) return ''
    const rows = []
    for (const f of UI_HELP_ROWS) if (e[f]) rows.push(`<b class='tooltip-header'>${escHtml(uiHelp_label(f))}:</b> <b class='tooltip-text ui-help-text'> ${escHtml(e[f])}</b>`)
    const head = `<b class='ui-help-title' data-help-key='${escHtml(key)}'>${escHtml(e.title || '')}</b>`
    return head + (rows.length ? '<br>' + rows.join('<br>') : '')
}

// строки объяснения для ЧУЖОЙ подсказки: { «Подпись»: текст } (текст НЕ экранирован; fields — какие поля брать, по умолчанию все строки)
export function uiHelp_rows(key, opts = {}, fields = UI_HELP_ROWS) {
    const e = uiHelp_entry(key, opts)
    const out = {}
    if (!e) return out
    for (const f of fields) if (e[f]) out[uiHelp_label(f)] = e[f]
    return out
}

// те же строки готовой разметкой (без шапки) — дописать в конец чужой подсказки: '<br>' + строки; '' — строк нет
export function uiHelp_rowsHtml(key, opts = {}, fields = UI_HELP_ROWS) {
    const e = uiHelp_entry(key, opts)
    if (!e) return ''
    const rows = []
    for (const f of fields) if (e[f]) rows.push(`<b class='tooltip-header'>${escHtml(uiHelp_label(f))}:</b> <b class='tooltip-text ui-help-text'> ${escHtml(e[f])}</b>`)
    return rows.length ? '<br>' + rows.join('<br>') : ''
}

// ---- точка расширения: объяснения ЗАПИСЕЙ (поставщики; следующая волна) ----
// поставщик: fn(id, segment, ctx) → { what, why, click, now, affects, stored, setting, hotkey } (строки уже переведены: предопределённые записи — t() в коде,
// записи базы — текст с бэка) либо null — ещё не загружено / нечего сказать (тогда поставщик сам запрашивает данные пачкой и по приходу зовёт
// uiHelp_recordReady). Первый непустой ответ побеждает; ошибка поставщика — счётчик stats.errors, подсказка не ломается
const _recordProviders = []
export function uiHelp_addRecordProvider(fn, name = '') {
    if (typeof fn !== 'function') return () => {}
    const p = { fn, name: String(name || 'provider' + (_recordProviders.length + 1)) }
    _recordProviders.push(p)
    return () => { const i = _recordProviders.indexOf(p); if (i >= 0) _recordProviders.splice(i, 1) }
}
export function uiHelp_recordProviders() { return _recordProviders.map(p => p.name) }
// IE 2026 09 24 / ODOO-… (заказ Игоря: объяснение элементов по Alt) · U1: запись поставщика ЦЕЛИКОМ — поля строк (what / why / how / click / now / affects / stored /
// setting / hotkey) + служебные title (название записи — для шапки там, где её нет) и source (откуда текст: db | code | record — контракт record_help) + provider
// (имя поставщика); null — ни один поставщик не дал непустых строк. Первый непустой ответ побеждает; ошибка поставщика — stats.errors, подсказка не ломается
const RECORD_META = ['title', 'source']
export function uiHelp_recordEntry(id, segment = '', ctx = {}) {
    if (id === undefined || id === null || id === '' || !_recordProviders.length || !uiHelp_enabled()) return null
    stats.recordAsks++
    for (const p of _recordProviders) {
        let e = null
        try { e = p.fn(String(id), String(segment || ''), ctx || {}) } catch (err) { stats.errors++; e = null }
        if (!e || typeof e !== 'object') continue
        const out = {}
        for (const f of UI_HELP_ROWS) { const v = e[f]; if (v !== undefined && v !== null && String(v).trim() !== '') out[f] = String(v).trim() }
        if (!Object.keys(out).length) continue
        for (const f of RECORD_META) { const v = e[f]; if (v !== undefined && v !== null && String(v).trim() !== '') out[f] = String(v).trim() }
        out.provider = p.name
        stats.recordHits++
        return out
    }
    return null
}
// IE 2026 09 24 / ODOO-… (заказ Игоря: объяснение элементов по Alt) · U1: подписи строк ЗАПИСИ отличаются от подписей объяснения ЭЛЕМЕНТА — в одной подсказке бывают оба (плитка рейла: «What it is» плитки и
// «About» самой страницы; ссылочная ячейка: «What it is» ссылки и «About» меры) — две строки «What it is» подряд читались бы как одна запутанная
export function uiHelp_recordLabel(field) {
    switch (field) {
        case 'what': return t('About')
        case 'why': return t('Purpose')
        default: return uiHelp_label(field)
    }
}
// строки объяснения записи для подсказки: { «Подпись»: текст } (текст НЕ экранирован) либо null
export function uiHelp_recordRows(id, segment = '', ctx = {}) {
    const e = uiHelp_recordEntry(id, segment, ctx)
    if (!e) return null
    const out = {}
    for (const f of UI_HELP_ROWS) if (e[f]) out[uiHelp_recordLabel(f)] = e[f]
    return Object.keys(out).length ? out : null
}
// те же строки готовой разметкой: '<br>' + строки (в конец существующей подсказки, до кнопок tipActions); '' — строк нет
export function uiHelp_recordRowsHtml(id, segment = '', ctx = {}) {
    const r = uiHelp_recordRows(id, segment, ctx)
    if (!r) return ''
    // IE 2026 09 24 / ODOO-… (заказ Игоря: объяснения записей) · R2: строки ЗАПИСИ помечены классом ui-help-record (пробы; подсказка с объяснением непрозрачна — App.vue)
    return '<br>' + Object.entries(r).map(([k, v]) => `<b class='tooltip-header'>${escHtml(k)}:</b> <b class='tooltip-text ui-help-text ui-help-record'> ${escHtml(v)}</b>`).join('<br>')
}
// видимая подсказка перерисовывается штатным повторным показом: контент — заново из функции подсказки её владельца (__wjTipFn), показ — тем же
// инстансом (по Alt / доживает — инстанс altTooltip, иначе инстанс ленивых подсказок), мимо дедупа обёртки show; pred(owner) — перерисовать только
// нужного владельца. Возвращает true, если перерисовал
// IE 2026 09 24 / ODOO-… (заказ Игоря: объяснение элементов по Alt) · U1: владелец — ЯЧЕЙКА ГРИДА (подсказка по Alt считается AttrGrid.cellTooltip по ячейке,
// функции элемента у неё нет): контент — заново тем же cellTooltip (точка курсора, если он ещё над ячейкой, иначе центр ячейки); только своя подсказка altTooltip
// (по Alt / доживает) — статичная подсказка Show tooltips запекается гридом при отрисовке
function _cellTipContent(el) {
    try {
        if (!el || !el.isConnected || !el.classList || !el.classList.contains('wj-cell')) return ''
        const host = el.closest('.wj-flexgrid')
        const grid = host && host.__vueGrid
        if (!grid || typeof grid.cellTooltip !== 'function') return ''
        const r = el.getBoundingClientRect()
        if (!(r.width > 0 && r.height > 0)) return ''
        let x = altTooltip._x, y = altTooltip._y
        if (!(x >= r.left && x <= r.right && y >= r.top && y <= r.bottom)) { x = r.left + r.width / 2; y = r.top + r.height / 2 }
        const res = grid.cellTooltip(el, x, y)
        return res && res.content ? String(res.content) : ''
    } catch (e) { return '' }
}
export function uiHelp_reshow(pred = null) {
    try {
        const tip = Tooltip._eTip
        if (!tip || !tip.isConnected || tip.offsetWidth === 0) return false
        const owner = tip[TTIP]
        if (!owner || (pred && !pred(owner))) return false
        const mine = altTooltip._el === owner
        let content = ''
        if (typeof owner.__wjTipFn === 'function') content = altTooltip.resolve ? altTooltip.resolve(owner.__wjTipFn) : String(owner.__wjTipFn() || '')
        else if (mine) content = _cellTipContent(owner)   // IE 2026 09 24 / ODOO-… (заказ Игоря: объяснение элементов по Alt) · U1: ячейка грида
        // IE 2026 09 24 / ODOO-… (заказ Игоря: объяснения записей) · R2: повторный показ статичной подсказки (v-wjTooltip: ссылочное поле формы AttrLink) — контент
        // заново из регистрации wijmo (поле перерисовано по ответу record_help), показ — её же инстансом; статичная подсказка ячейки грида (Show tooltips) запекается при отрисовке — не здесь
        let staticInst = null
        if (!content && typeof owner.__wjTipFn !== 'function' && !(owner.classList && owner.classList.contains('wj-cell')) && owner.__wjTipInst && typeof owner.__wjTipInst.getTooltip === 'function') {
            try { content = String(owner.__wjTipInst.getTooltip(owner) || ''); staticInst = owner.__wjTipInst } catch (e) { content = '' }
        }
        if (!content) return false
        if (mine) altTooltip._content = content
        altTooltip.lastKey = null
        altTooltip.showing = true
        try { (mine ? (altTooltip._inst || altTooltip.tip) : (staticInst || altTooltip.tip)).show(owner, content) } finally { altTooltip.showing = false }
        stats.reshows++
        return true
    } catch (e) { return false }
}
// поставщик получил данные записи — видимая подсказка перерисовывается; событие для владельцев со своим показом
// IE 2026 09 24 / ODOO-… (заказ Игоря: объяснение элементов по Alt) · U1: opts.reshow === false — только событие (пачка записей: событие на каждую, повторный показ — один на пачку, uiHelp_recordsReady)
export function uiHelp_recordReady(id, segment = '', opts = {}) {
    stats.recordReady++
    try { window.dispatchEvent(new CustomEvent('ui-help:record', { detail: { id: String(id ?? ''), segment: String(segment || '') } })) } catch (e) { /* без window */ }
    return (opts && opts.reshow === false) ? false : uiHelp_reshow()
}
export function uiHelp_recordsReady(items) {
    const list = (items || []).filter(it => it && it.id !== undefined && it.id !== null && it.id !== '')
    for (const it of list) uiHelp_recordReady(it.id, it.segment, { reshow: false })
    return list.length ? uiHelp_reshow() : false
}

// IE 2026 09 24 / ODOO-… (заказ Игоря: объяснение элементов по Alt) · U1: ГОТОВЫЙ ПОСТАВЩИК «ПАЧКОЙ» — под пакетный метод бэка record_help
// (executeBackendMethod method 'record_help', params { items: [{ id, segment }], lang } → { record_help: { '<segment>|<id>': { what, why, how, source, title } | null } }).
// fetchBatch(items, lang) → Promise<{ '<segment>|<id>': запись | null }> — транспорт даёт владелец (R2: вызов бэка), здесь только механика:
//   - запрос записи НЕ блокирует подсказку: поставщик сразу отдаёт null (строк нет), ключ встаёт в очередь; одна пачка на паузу opts.delayMs (40 мс),
//     не больше opts.max (200) записей в пачке, остаток — следующей;
//   - ответ кэшируется по ключу '<segment>|<id>' (segment может быть '' — бэк ищет запись по id); null / нет ключа в ответе — «объяснения нет», повторно
//     не спрашивается; смена языка (opts.lang() — по умолчанию язык интерфейса) сбрасывает кэш, ответ на старом языке отбрасывается;
//   - ошибка транспорта — записи пачки не спрашиваются снова opts.retryMs (30 с); счётчики stats;
//   - пришёл ответ — событие 'ui-help:record' на каждую запись с объяснением и ОДИН повторный показ видимой подсказки (uiHelp_recordsReady).
// Возвращает { off, provider, cache, stats, invalidate(id?, segment?) }; opts.register === false — поставщик не регистрируется (ручная регистрация / юнит).
export function uiHelp_recordBatchProvider(fetchBatch, opts = {}) {
    const delay = Math.max(0, +(opts.delayMs ?? 40) || 0)
    const max = Math.max(1, +(opts.max ?? 200) || 200)
    const retryMs = Math.max(0, +(opts.retryMs ?? 30000) || 0)
    const langOf = () => { try { return String((typeof opts.lang === 'function' ? opts.lang() : (opts.lang ?? getLanguage())) || '') } catch (e) { return '' } }
    const keyOf = (id, segment) => `${segment || ''}|${id}`
    const cache = new Map(), pending = new Map(), inflight = new Set(), failed = new Map()
    const st = { asks: 0, hits: 0, empty: 0, queued: 0, batches: 0, items: 0, errors: 0, stale: 0 }
    let timer = null, lang = null
    const flush = () => {
        timer = null
        const items = [...pending.values()].slice(0, max)
        for (const it of items) { const k = keyOf(it.id, it.segment); pending.delete(k); inflight.add(k) }
        if (pending.size) timer = setTimeout(flush, delay)
        if (!items.length) return
        const lg = lang
        st.batches++; st.items += items.length
        let p
        try { p = Promise.resolve(fetchBatch(items.map(it => ({ id: it.id, segment: it.segment })), lg)) } catch (e) { p = Promise.reject(e) }
        p.then((map) => {
            for (const it of items) inflight.delete(keyOf(it.id, it.segment))
            if (lg !== lang) { st.stale++; return }   // язык сменился, пока шёл запрос — ответ устарел (кэш уже сброшен)
            const ready = []
            for (const it of items) {
                const k = keyOf(it.id, it.segment)
                const e = (map && typeof map === 'object' && Object.prototype.hasOwnProperty.call(map, k)) ? map[k] : null
                const entry = (e && typeof e === 'object') ? e : null
                cache.set(k, entry)
                if (entry) ready.push(it)
            }
            if (ready.length) uiHelp_recordsReady(ready)
        }).catch(() => {
            st.errors++
            const now = Date.now()
            for (const it of items) { const k = keyOf(it.id, it.segment); inflight.delete(k); failed.set(k, now) }
        })
    }
    const provider = (id, segment) => {
        const lg = langOf()
        if (lg !== lang) { cache.clear(); failed.clear(); pending.clear(); lang = lg }
        const seg = String(segment || '')
        const k = keyOf(id, seg)
        st.asks++
        if (cache.has(k)) { const e = cache.get(k); if (e) st.hits++; else st.empty++; return e }
        if (inflight.has(k) || pending.has(k)) return null
        const f = failed.get(k)
        if (f !== undefined && Date.now() - f < retryMs) return null
        pending.set(k, { id: String(id), segment: seg })
        st.queued++
        if (!timer) timer = setTimeout(flush, delay)
        return null
    }
    const off = opts.register === false ? () => {} : uiHelp_addRecordProvider(provider, opts.name || 'records')
    return {
        off, provider, cache, stats: st,
        invalidate(id, segment) { if (id === undefined) { cache.clear(); failed.clear() } else { cache.delete(keyOf(id, segment)); failed.delete(keyOf(id, segment)) } },
    }
}

// IE 2026 09 24 / ODOO-… (заказ Игоря: объяснение элементов по Alt) · U6 (регрессия ie-dm7 #43146, 25.09): ЯВНЫЙ ПРОТОКОЛ ВЛАДЕЛЬЦА Alt-подсказки области.
// Курсор внутри элемента [data-alt-owner="<имя>"] (имя ≠ 'uiHelp') и window[<имя>].isActive() истинно — объяснения uiHelp в этой области уступают
// полностью: подсказку даёт владелец (график формы ячейки — cellChartAlt, ODOO-5800). el — элемент объяснения: проверка только когда курсор над ним;
// x, y — точка курсора (по умолчанию — последняя позиция мыши altTooltip: altTooltip._x / _y обновляются на каждом движении мыши)
export function uiHelp_ownerYields(el, x, y) {
    try {
        if (x === undefined || y === undefined) { x = altTooltip._x; y = altTooltip._y }
        if (!(x >= 0 && y >= 0) || typeof document === 'undefined' || typeof document.elementFromPoint !== 'function') return false
        const tgt = document.elementFromPoint(x, y)
        if (!tgt || (el && !el.contains(tgt))) return false
        const o = tgt.closest && tgt.closest('[data-alt-owner]')
        if (!o) return false
        const name = o.getAttribute('data-alt-owner')
        if (!name || name === 'uiHelp') return false
        const api = typeof window !== 'undefined' ? window[name] : null
        return !!(api && typeof api.isActive === 'function' && api.isActive())
    } catch (e) { return false }
}
// ключ карточки uiHelp в показанной подсказке (шапка <b class='ui-help-title' data-help-key=…>; браузер может переписать кавычки)
const cardKeyOf = (html) => { const m = /data-help-key=(["'])(.*?)\1/.exec(String(html || '')); return m ? m[2] : '' }

// ---- директива ----
function normalize(value) {
    if (!value) return null
    if (typeof value === 'string') return { key: value }
    if (typeof value === 'object' && typeof value.key === 'string' && value.key) return value
    return null
}
function readBinding(b) {
    let state = null, vars = {}
    try { state = typeof b.state === 'function' ? b.state() : (b.state === undefined ? null : b.state) } catch (e) { state = null }
    try { vars = (typeof b.vars === 'function' ? b.vars() : b.vars) || {} } catch (e) { vars = {} }
    return { state, vars }
}

// короткое имя для обычного наведения: binding.short (строка / функция) → перенесённый нативный title → статичная v-wjTooltip другого инстанса
function shortOf(el) {
    const b = el && el.__uiHelp
    let s = ''
    if (b && b.short !== undefined && b.short !== null) { try { s = typeof b.short === 'function' ? b.short() : b.short } catch (e) { s = '' } }
    if (!s && el.__uiHelpTitle) s = el.__uiHelpTitle
    if (!s && typeof el.__nativeTitle === 'string') s = el.__nativeTitle   // IE 2026 09 25 / ODOO-… (правило Игоря: подсказки только по Alt или опции): title, снятый utils/nativeTitles.js
    if (!s) { try { const inst = el.__wjTipInst; if (inst && inst !== altTooltip.tip && typeof inst.getTooltip === 'function') s = inst.getTooltip(el) } catch (e) { s = '' } }
    return String(s || '').trim()
}
const shortDelayMs = () => { try { const s = storeOf(); const v = s && typeof s.setting === 'function' ? +s.setting('fe.ux.tooltipShowDelayMs', 400) : 400; return v >= 0 ? v : 400 } catch (e) { return 400 } }
// IE 2026 09 25 / ODOO-… (правило Игоря: подсказки только по Alt или опции): прежнее поведение (короткое имя по наведению без Alt / опции) — только по настройке fe.ux.hoverTooltips=true
const hoverTipsOn = () => { try { if (typeof altTooltip.hoverTipsOn === 'function') return !!altTooltip.hoverTipsOn(); const s = storeOf(); return !!(s && typeof s.setting === 'function' && s.setting('fe.ux.hoverTooltips', false) === true) } catch (e) { return false } }

// контент подсказки элемента (функция регистрации __wjTipFn): '' — выключено / заглушено / ключа нет → altTooltip идёт к подсказке родителя
export function uiHelp_content(el) {
    const b = el && el.__uiHelp
    if (!b || !b.key || el[MUTE] || !uiHelp_enabled()) return ''
    if (uiHelp_ownerYields(el)) return ''   // U6 (регрессия ie-dm7 #43146, 25.09): курсор в области владельца (data-alt-owner) — объяснение уступает
    const { state, vars } = readBinding(b)
    let html = uiHelp_html(b.key, { state, vars })
    if (html) stats.renders++
    // IE 2026 09 24 / ODOO-… (заказ Игоря: объяснение элементов по Alt) · U3 (накат 26.09): хук after: binding.after — функция (или строка) с html, который дописывается ПОСЛЕ строк объяснения: техсводка и объяснение записи у бейджа / поля названия / полосы
    // шапки виджета (Widget.tooltip_tail) — как у подсказки контейнера, которую эти элементы накрывают своим объяснением; ошибка функции — хвоста нет (stats.errors)
    if (html && b.after !== undefined && b.after !== null) { try { html += String((typeof b.after === 'function' ? b.after() : b.after) || '') } catch (e) { stats.errors++ } }
    return html
}

const uiHelp = {
    stats,
    enabled: uiHelp_enabled,
    content: uiHelp_content,
    html: (key, opts) => uiHelp_html(key, opts || {}),
    entry: (key, opts) => uiHelp_entry(key, opts || {}),
    keys: () => uiHelp_keys(),
    rows: (key, opts, fields) => uiHelp_rows(key, opts || {}, fields),
    rowsHtml: (key, opts, fields) => uiHelp_rowsHtml(key, opts || {}, fields),
    short: (el) => shortOf(el),
    hoverTipsOn: () => hoverTipsOn(),   // IE 2026 09 25 / ODOO-… (правило Игоря: подсказки только по Alt или опции)
    addRecordProvider: (fn, name) => uiHelp_addRecordProvider(fn, name),
    recordProviders: () => uiHelp_recordProviders(),
    recordRows: (id, segment, ctx) => uiHelp_recordRows(id, segment, ctx),
    recordEntry: (id, segment, ctx) => uiHelp_recordEntry(id, segment, ctx),   // IE 2026 09 24 / ODOO-… (заказ Игоря: объяснение элементов по Alt) · U1
    recordReady: (id, segment, opts) => uiHelp_recordReady(id, segment, opts),
    recordsReady: (items) => uiHelp_recordsReady(items),   // IE 2026 09 24 / ODOO-… (заказ Игоря: объяснение элементов по Alt) · U1
    recordBatch: (fetchBatch, opts) => uiHelp_recordBatchProvider(fetchBatch, opts),   // IE 2026 09 24 / ODOO-… (заказ Игоря: объяснение элементов по Alt) · U1: поставщик «пачкой» (контракт record_help)
    reshow: (pred) => uiHelp_reshow(pred),
    // привязка элемента (beforeMount / updated): binding хранится на элементе — функция контента читает его в момент показа
    bind(el, value, isUpdate = false) {
        const b = normalize(value)
        if (!b) { this.unbind(el); return }
        el.__uiHelp = b
        if (el.getAttribute('data-help') !== b.key) el.setAttribute('data-help', b.key)
        if (!isUpdate) stats.binds++
        if (uiHelp_enabled()) {
            if (!el.__uiHelpFn) el.__uiHelpFn = () => uiHelp_content(el)
            if (el.__wjTipFn !== el.__uiHelpFn && !el[MUTE]) altTooltip._bindFn(el, el.__uiHelpFn)   // заглушённый (панель открыта) — без регистрации
            el.__uiHelpActive = true
            this._titleToAria(el)
            if (!el.__uiHelpEnter) { el.__uiHelpEnter = (e) => this._onEnter(e); el.addEventListener('mouseenter', el.__uiHelpEnter) }
            if (!el.__uiHelpLeave) { el.__uiHelpLeave = () => this._shortCancel(el); el.addEventListener('mouseleave', el.__uiHelpLeave) }
            if (isUpdate) this._refreshShown(el)
        } else {
            this._deactivate(el)
        }
    },
    unbind(el) {
        if (!el) return
        this._deactivate(el)
        this._shortCancel(el)
        delete el.__uiHelp
        delete el.__uiHelpFn
        delete el[MUTE]
        try { el.removeAttribute('data-help') } catch (e) { /* элемент ушёл */ }
    },
    _deactivate(el) {
        if (el.__uiHelpActive) {
            if (el.__wjTipFn === el.__uiHelpFn) { this.hideIfOwner(el); altTooltip._bindFn(el, null) }
            el.__uiHelpActive = false
        }
        if (el.__uiHelpEnter) { el.removeEventListener('mouseenter', el.__uiHelpEnter); delete el.__uiHelpEnter }
        if (el.__uiHelpLeave) { el.removeEventListener('mouseleave', el.__uiHelpLeave); delete el.__uiHelpLeave }
        this._shortCancel(el)
        this._titleRestore(el)
    },
    // нативный title → aria-label (подпись для чтения с экрана остаётся), чтобы не всплывало второе окно; выключено — title возвращается
    _titleToAria(el) {
        const tt = el.getAttribute('title')
        if (tt === null) return
        el.__uiHelpTitle = tt
        el.removeAttribute('title')
        if (!el.hasAttribute('aria-label') || el.__uiHelpAria) { el.setAttribute('aria-label', tt); el.__uiHelpAria = true }
        stats.titles++
    },
    _titleRestore(el) {
        if (el.__uiHelpTitle !== undefined) {
            if (!el.hasAttribute('title')) el.setAttribute('title', el.__uiHelpTitle)
            delete el.__uiHelpTitle
        }
        if (el.__uiHelpAria) { el.removeAttribute('aria-label'); delete el.__uiHelpAria }
    },
    // заглушить объяснение (кнопка-триггер, пока её панель открыта): как прежде со статичной подсказкой (_tipMute снимал её регистрацию) — показанная
    // прячется, регистрация снимается (Alt идёт к подсказке родителя), снятие заглушки регистрирует снова
    mute(el, on) {
        if (!el) return
        this._shortCancel(el)
        if (on) {
            el[MUTE] = true
            this.hideIfOwner(el)
            if (el.__uiHelpFn && el.__wjTipFn === el.__uiHelpFn) altTooltip._bindFn(el, null)
        } else {
            delete el[MUTE]
            if (el.__uiHelpActive && el.__uiHelpFn && el.__wjTipFn !== el.__uiHelpFn && uiHelp_enabled()) altTooltip._bindFn(el, el.__uiHelpFn)
        }
    },
    isActive(el) { return !!(el && el.__uiHelpActive && uiHelp_enabled()) },
    ownerYields: (el, x, y) => uiHelp_ownerYields(el, x, y),   // U6 (регрессия ie-dm7 #43146, 25.09): протокол владельца области (data-alt-owner)
    // спрятать подсказку, если она сейчас принадлежит элементу (по Alt / доживает — через altTooltip, иначе инстанс ленивых подсказок)
    hideIfOwner(el) {
        try {
            if (altTooltip._el === el) { if (altTooltip._lingerEl) altTooltip._lingerCancel(true); else altTooltip._hide(); return }
            const tip = Tooltip._eTip
            if (tip && tip.isConnected && tip[TTIP] === el) altTooltip.tip.hide()
        } catch (e) { /* подсказки нет */ }
    },
    // вход курсора: при зажатом Alt решает altTooltip; режим Show tooltips — полное объяснение сразу (wijmo сам не покажет подсказку вложенного
    // элемента, пока видна подсказка внешнего — курсор внутри её владельца; отложенный показ внешнего, тот же инстанс, снимается); обычное
    // наведение — КОРОТКОЕ имя после паузы (как прежний нативный title / статичная подсказка), тем же элементом подсказки платформы
    _onEnter(e) {
        const el = e && e.currentTarget
        if (!el || altTooltip.held || !el.__uiHelpActive || el[MUTE]) return
        if (!uiHelp_enabled()) return
        const s = storeOf()
        if (!s || !s.showTooltip) { if (hoverTipsOn()) this._shortSchedule(el); return }   // IE 2026 09 25 / ODOO-… (правило Игоря: подсказки только по Alt или опции)
        try {
            const tip = Tooltip._eTip
            if (tip && tip.isConnected && tip.offsetWidth > 0 && tip[TTIP] === el) return
            const inst = altTooltip.tip
            if (typeof inst._clearTimeouts === 'function') inst._clearTimeouts()
            inst.show(el, '\u200b')   // обёртка show (App.vue) берёт контент из __wjTipFn
            stats.enters++
        } catch (err) { /* элемент исчез */ }
    },
    _shortSchedule(el) {
        this._shortCancel(el)
        if (!shortOf(el)) return
        el.__uiHelpShortT = setTimeout(() => { el.__uiHelpShortT = null; this._shortShow(el) }, shortDelayMs())
    },
    _shortCancel(el) {
        if (el && el.__uiHelpShortT) { clearTimeout(el.__uiHelpShortT); el.__uiHelpShortT = null }
    },
    _shortShow(el) {
        try {
            if (!el.isConnected || altTooltip.held || el[MUTE] || !el.__uiHelpActive || !uiHelp_enabled()) return
            const s = storeOf()
            if (s && s.showTooltip) return
            if (!hoverTipsOn()) return   // IE 2026 09 25 / ODOO-… (правило Игоря: подсказки только по Alt или опции)
            if (typeof el.matches === 'function' && !el.matches(':hover')) return   // курсор уже ушёл
            const text = shortOf(el)
            if (!text) return
            const tip = Tooltip._eTip
            if (tip && tip.isConnected && tip.offsetWidth > 0 && tip[TTIP] === el) return
            // обёртка show (App.vue) пропускает ленивые подсказки только по Alt / Show tooltips — короткое имя показывается мимо этого фильтра
            altTooltip.showing = true
            try { altTooltip.tip.show(el, `<span class='ui-help-short'>${escHtml(text)}</span>`) } finally { altTooltip.showing = false }
            stats.shorts++
        } catch (e) { /* элемент исчез */ }
    },
    // привязка обновилась (клик по звезде сменил состояние) — показанное объяснение этого элемента перерисовывается на месте
    _refreshShown(el) {
        try {
            const tip = Tooltip._eTip
            // U6 (регрессия ie-dm7 #43146, 25.09): перерисовывается только СВОЯ карточка — ключ шапки показанной подсказки = ключу элемента; на том же элементе бывает
            // чужой источник «по точке» (хост графика формы ячейки — cellChartAlt): его показанную подсказку не трогаем
            const key = el.__uiHelp && el.__uiHelp.key
            const mineAlt = altTooltip._el === el && (altTooltip.held || altTooltip._lingerEl) && !!key && cardKeyOf(altTooltip._content) === escHtml(key)
            const tipTitle = tip && tip.querySelector && tip.querySelector('.ui-help-title')
            const mineHover = !!(tip && tip.isConnected && tip.offsetWidth > 0 && tip[TTIP] === el && tipTitle && tipTitle.getAttribute('data-help-key') === key)
            if (!mineAlt && !mineHover) return
            const html = uiHelp_content(el)
            if (!html) return
            if (mineAlt) altTooltip._content = html
            if (!(tip && tip.isConnected && tip[TTIP] === el)) return
            // сравнение в нормализованной форме (браузер сериализует кавычки атрибутов по-своему) — без лишней перерисовки выделенного текста подсказки
            const norm = document.createElement('div')
            norm.innerHTML = html
            if (norm.innerHTML === tip.innerHTML) return
            tip.innerHTML = html
            stats.refreshes++
        } catch (e) { /* подсказки нет */ }
    },
    // пересинхронизировать все элементы с объяснением (после смены fe.ux.uiHelp во время работы)
    refreshAll() {
        let n = 0
        try { for (const el of document.querySelectorAll('[data-help]')) { if (el.__uiHelp) { this.bind(el, el.__uiHelp, true); n++ } } } catch (e) { /* нет DOM */ }
        return n
    },
}

// счётчик ПОКАЗОВ по ключам: полное объяснение стало видимым у элемента (переход: до show владелец был другим, подсказки не было или было короткое имя)
if (!Tooltip.prototype.__uiHelpPatched) {
    Tooltip.prototype.__uiHelpPatched = true
    const orig = Tooltip.prototype.show
    Tooltip.prototype.show = function (...args) {
        let wasOwner = null, wasFull = false
        try { const e = Tooltip._eTip; wasFull = !!(e && e.isConnected && e.offsetWidth > 0 && e.querySelector('.ui-help-title')); wasOwner = e ? e[TTIP] : null } catch (err) { /* нет элемента */ }
        const r = orig.apply(this, args)
        try {
            const e = Tooltip._eTip
            const owner = e && e.isConnected && e.offsetWidth > 0 ? e[TTIP] : null
            if (owner && owner.__uiHelp && (!wasFull || wasOwner !== owner) && e.querySelector('.ui-help-title')) {
                const k = owner.__uiHelp.key
                stats.shows[k] = (stats.shows[k] || 0) + 1
                stats.total++
            }
        } catch (err) { /* счётчик вспомогательный */ }
        return r
    }
}

export const uiHelpDirective = {
    beforeMount(el, binding) { uiHelp.bind(el, binding.value, false) },
    updated(el, binding) { uiHelp.bind(el, binding.value, true) },
    unmounted(el) { uiHelp.unbind(el) },
}

if (typeof window !== 'undefined') window._uiHelp = uiHelp

export default uiHelp
